<template>
  <el-submenu v-if="hasChildren" :index="menuKey">
    <template slot="title">
      <i :class="menu.icon || 'el-icon-menu'"></i>
      <span>{{ menu.name }}</span>
      <el-badge v-if="showApprovalCount" :value="todoCount" class="approval-count" />
    </template>
    <sidebar-menu-item v-for="child in menu.children" :key="child.id || child.path" :menu="child" />
  </el-submenu>
  <el-menu-item v-else :index="menu.path || menuKey" :disabled="!menu.path" :title="menu.path ? '' : '未配置页面入口'">
    <i :class="menu.icon || 'el-icon-menu'"></i>
    <span slot="title">{{ menu.name }}</span>
    <el-badge v-if="showApprovalCount" :value="todoCount" class="approval-count" />
  </el-menu-item>
</template>

<script>
export default {
  name: 'SidebarMenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasChildren() {
      return this.menu.children && this.menu.children.length > 0
    },
    menuKey() {
      return this.menu.id || this.menu.path || this.menu.name
    },
    todoCount() {
      const user = this.$store.getters.userInfo || {}
      return Number(user.todoCount || 0)
    },
    showApprovalCount() {
      return this.menu.name === '过程审批' && this.todoCount > 0
    }
  }
}
</script>

<style scoped>
.approval-count {
  margin-left: 4px;
}
</style>
